import type { PaddingSize } from "../content-section/index.marko";
import s from "./style.module.css";
export interface Input {
    col: Marko.AttrTag<Marko.HTML.Div>;
    emphasis?: "start" | "end" | "equal";
    paddingBlock?: (PaddingSize | null)[];
}

<const/{ emphasis, paddingBlock, col: cols }=input>

<content-section
    class=s.section
    data-emphasis=emphasis
    paddingBlock=paddingBlock>
    <for|col, i| of=cols>
        <if=i < 2>
            <${col.content}/>
        </if>
    </for>
</content-section>
